const $ = require('jquery');
const cookie = require('jquery.cookie');
const validation = require('jquery-validation');
const bootstrap = require('bootstrap');
const moment = require('moment');

window.$ = window.jQuery = $;

const pushy = require('./vendor/pushy-custom');
const custom = require('./custom-validation');
const unobtrusive = require('jquery-validation-unobtrusive');
const expressive = require('expressive-annotations-validate');
const mask = require('jquery-mask-plugin');

const dataTables = require('datatables');
const verify = require('./verify');
const cardapp = require('./card-app');
require('./vendor/allytm-stub.min');

(function () {
    //////////////////////////////////////////////////////////////////////
    // VIEWPORT
    //////////////////////////////////////////////////////////////////////
    var windowSize = $(window).width();
    var ua = navigator.userAgent.toLowerCase();
    var isiPad = navigator.userAgent.match(/iPad/i) !== null;
    if (isiPad) {
        $('meta[name="viewport"]').attr('content', 'width=1024');
        //$('body').addClass('iPad');
    }
    $(window).on("orientationchange", function () {
        var windowSize = $(window).width();
        if (windowSize > 750) {
            $('meta[name="viewport"]').attr('content', 'width=1250');
        }
    });

    //////////////////////////////////////////////////////////////////////
    // FACEBOOK INIT
    //////////////////////////////////////////////////////////////////////

    window.fbAsyncInit = function () {
        FB.init({
            appId: 'your-app-id',
            xfbml: true,
            version: 'v2.7'
        });
    };

    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));


    //////////////////////////////////////////////////////////////////////
    // METHODS
    //////////////////////////////////////////////////////////////////////
    var highlight = function (element, errorClass, validClass) {
        $(element).addClass(errorClass).removeClass(validClass);
        $(element).parent().addClass(errorClass);
    };

    var unhighlight = function (element, errorClass, validClass) {
        $(element).removeClass(errorClass).addClass(validClass);
        $(element).parent().removeClass(errorClass);
    };

    var setUsernameCookie = function (val) {
        $.cookie('username', val, { expires: 365 });
    }

    var clearUsernameCookie = function () {
        $.removeCookie('username');
    }

    var setUsernameValuesFromCookie = function () {
        var u = $.cookie('username');

        $('#d-username').val(u);
        $('#m-username').val(u);
        $('#h-username').val(u);

        $('#d-save').prop('checked', true);
        $('#m-save').prop('checked', true);
        $('#h-save').prop('checked', true);
    }

    //////////////////////////////////////////////////////////////////////
    // VARIABLES
    //////////////////////////////////////////////////////////////////////
    var loginFormValidationRules = {
        rules: {
            UserId: {
                required: true
            },
            Password: {
                required: true
            }
        },
        messages: {
            UserId: 'Please enter your username.',
            Password: 'Please enter your password.'
        },
        highlight: highlight,
        unhighlight: unhighlight
    };

    var offerCodeValidationRules = {
        onfocusout: function (element) {
            $(element).valid();
        },
        rules: {
            offerCode: {
                required: true,
                regex: "^[0-9\- ]*$"
            },
            accessCode: {
                required: true,
                regex: "^[0-9a-zA-Z]*$"
            }
        },
        messages: {
            offerCode: {
                required: 'Please enter your reservation number.',
                regex: 'Please enter a valid reservation number.'
            },
            accessCode: {
                required: 'Please enter your access code.',
                regex: 'Please enter a valid access code.'
            }
        },
        highlight: highlight,
        unhighlight: unhighlight
    };

    //////////////////////////////////////////////////////////////////////
    // RUN ON PAGE LOAD
    //////////////////////////////////////////////////////////////////////

    // Login Forms
    $('#desktop-login-form').validate(loginFormValidationRules);
    $('#mobile-login-form').validate(loginFormValidationRules);
    $('#homepage-login-form').validate(loginFormValidationRules);

    $('#desktop-login-form').submit(function () {
        if ($('#d-save').prop('checked')) {
            setUsernameCookie($('#d-username').val());
        } else {
            clearUsernameCookie();
        }
    });

    $('#mobile-login-form').submit(function () {
        if ($('#m-save').prop('checked')) {
            setUsernameCookie($('#m-username').val());
        } else {
            clearUsernameCookie();
        }
    });

    $('#homepage-login-form').submit(function () {
        if ($('#h-save').prop('checked')) {
            setUsernameCookie($('#h-username').val());
        } else {
            clearUsernameCookie();
        }
    });

    if ($.cookie('username') != undefined) {
        setUsernameValuesFromCookie();
    }

    // Offer Code Form
    $('#offer-code-submission').validate(offerCodeValidationRules);
    $("#offer-code-submission").removeAttr("novalidate");

    $('#offer-code-submission').submit(function () {
        if ($(this).valid()) {
            $(':submit', this).attr('disabled', 'disabled');
        }
    });

    // Social Share
    $('.twitter').click(function (e) {
        e.preventDefault();

        window.open(
            'https://twitter.com/intent/tweet?url=' + encodeURIComponent(document.URL),
            '',
            'width=500,height=300,resizable,scrollbars=yes,status=1'
        );
    });


    $('.facebook').click(function (e) {
        e.preventDefault();

        FB.ui({
            method: 'share',
            href: document.URL,
        }, function (response) { });
    });


    $('.pinterest').click(function (e) {
        PinUtils.pinOne({
            media: $('meta[property="og:image"]').attr('content')
        });
    });

    //////////////////////////////////////////////////////////////////////
    // NAVIGATION
    //////////////////////////////////////////////////////////////////////

    // Desktop

    // Hide login overlay if user tabs outside of the desktop login form
    $('ul#navbar-nav li a, main#container, footer').focusin(function () {
        $('#desktopSignIn').removeClass('show');
        $('.login-desktop-nav').attr('aria-expanded', function (i, attr) {
            return attr === 'true' ? 'false' : 'false';
        });
    });

    // Mobile
    $('#mobile-login-trigger').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('#mobile-login-form').slideToggle(200);
    });

    //////////////////////////////////////////////////////////////////////
    // LANDING PAGE STICKY NAV
    //////////////////////////////////////////////////////////////////////
    // Get the height of nav bar, make sticky when scrolled past trigger
    // offset body by height of navbar to avoid awkward jump when active
    // on mobile, no offset bump needed since cta only present when active
    $(window).on("scroll", function () {
        var scrollPos = $(document).scrollTop();
        var triggerPos = $("#sticky-trigger").offset().top;
        var navHeight = $("#custom-sticky").outerHeight();
        if (triggerPos <= scrollPos) {
            $("#custom-sticky").addClass("fixed-top");
            if ($(window).outerWidth() > 768) {
                $("body").css('margin-top', navHeight + 'px');
            } 
        }
        else {
            $("#custom-sticky").removeClass("fixed-top");
            $("body").css('margin-top', '0px');
        }
    });


    //////////////////////////////////////////////////////////////////////
    // FLOATING FORM LABELS
    //////////////////////////////////////////////////////////////////////
    $(".float-form input, .float-form textarea").each(function () {
        if ($(this).val() != "") {
            $(this).parent().addClass("float");
        }
    });    

    $(".float-form input, .float-form textarea").bind('focus change', function () {
        $(this).parent().addClass("float");
    });
    $(".float-form input, .float-form textarea").bind('blur', function () {
        var input = $(this);
        setTimeout(function () {
            var val = input.val();
            if (val === "") {
                input.parent().removeClass("float");
            }
        });
    });
})();


// Progress bar class for FED (FSFALLYP1-158)
var currentSection = $('*[id*=section-]').attr('id');
$('.progress-bar').addClass(currentSection);

// Mobile accordion awkward functionality (because comps said so >:|)
if (currentSection == 'section-welcome') {
    $('#mobileAccordion li:not(:nth-of-type(1))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}
if (currentSection == 'section-contact') {
    $('#mobileAccordion li:not(:nth-of-type(2))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}
if (currentSection == 'section-finance') {
    $('#mobileAccordion li:not(:nth-of-type(3))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}
if (currentSection == 'section-security') {
    $('#mobileAccordion li:not(:nth-of-type(4))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}